/*
 * Action Types
 */
export enum UserIpsTypes {
  LIST_USER_IPS_REQUEST = '@userIps/LIST_USER_IPS_REQUEST',
  LIST_USER_IPS_SUCCESS = '@userIps/LIST_USER_IPS_SUCCESS',
  LIST_USER_IPS_FAILURE = '@userIps/LIST_USER_IPS_FAILURE',

  GET_USER_IP_REQUEST = '@userIps/GET_USER_IP_REQUEST',
  GET_USER_IP_SUCCESS = '@userIps/GET_USER_IP_SUCCESS',
  GET_USER_IP_FAILURE = '@userIps/GET_USER_IP_FAILURE',

  FILTER_USER_IPS_REQUEST = '@userIps/FILTER_USER_IPS_REQUEST',
  FILTER_USER_IPS_SUCCESS = '@userIps/FILTER_USER_IPS_SUCCESS',
  FILTER_USER_IPS_FAILURE = '@userIps/FILTER_USER_IPS_FAILURE',

  CREATE_USER_IP_REQUEST = '@userIps/CREATE_USER_IP_REQUEST',
  CREATE_USER_IP_SUCCESS = '@userIps/CREATE_USER_IP_SUCCESS',
  CREATE_USER_IP_FAILURE = '@userIps/CREATE_USER_IP_FAILURE',

  CREATE_LIST_USER_IPS_REQUEST = '@userIps/CREATE_LIST_USER_IPS_REQUEST',
  CREATE_LIST_USER_IPS_SUCCESS = '@userIps/CREATE_LIST_USER_IPS_SUCCESS',
  CREATE_LIST_USER_IPS_FAILURE = '@userIps/CREATE_LIST_USER_IPS_FAILURE',

  UPDATE_USER_IP_REQUEST = '@userIps/UPDATE_USER_IP_REQUEST',
  UPDATE_USER_IP_SUCCESS = '@userIps/UPDATE_USER_IP_SUCCESS',
  UPDATE_USER_IP_FAILURE = '@userIps/UPDATE_USER_IP_FAILURE',

  DELETE_USER_IP_REQUEST = '@userIps/DELETE_USER_IP_REQUEST',
  DELETE_USER_IP_SUCCESS = '@userIps/DELETE_USER_IP_SUCCESS',
  DELETE_USER_IP_FAILURE = '@userIps/DELETE_USER_IP_FAILURE',
}

/*
 * Data types
 */
export interface IncludedUserInterface {
  id: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  resourceIpId: string;
}

export interface UserIpInterface {
  id: string;
  name: string;
  start: string;
  end: string;
  type: number;
  owner: string;
  group?: string;
  UserIps?: IncludedUserInterface[];
  createdAt?: string;
  updatedAt?: string;
}

/*
 * State type
 */
export interface UserIpsState {
  readonly userIpsList: UserIpInterface[];
  readonly userIpData: UserIpInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
